export const LSKeys = {
    user: 'user'
}